// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1hWfc","header":"ReportDetails_header__1KCEO","title":"ReportDetails_title__21cKD","left":"ReportDetails_left__guafB"};